import { LEADERBOARD } from '../config/leaderboard';
import { decodeReplay, type Replay } from './ReplayFormat';

/** Bound both the wait and streamed bytes before decoding an untrusted demo. */
export async function loadReplay(url: string, signal: AbortSignal): Promise<Replay> {
  const response = await fetch(url, {
    signal: AbortSignal.any([signal, AbortSignal.timeout(LEADERBOARD.requestTimeoutMs)]),
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
  });
  if (!response.ok || !response.body) throw new Error('Replayta ei löytynyt tai palvelin ei vastaa.');
  const reader = response.body.getReader();
  const chunks: Uint8Array[] = [];
  let length = 0;
  try {
    for (;;) {
      const chunk = await reader.read();
      if (chunk.done) break;
      length += chunk.value.length;
      if (length > 1_500_000) throw new Error('Replay on liian suuri.');
      chunks.push(chunk.value);
    }
  } finally { await reader.cancel(); }
  const bytes = new Uint8Array(length);
  let offset = 0;
  for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.length; }
  return decodeReplay(bytes);
}
